import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { PeriodicElement } from '../../../../../shared/elements/data-table/data-table.component';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-prop-table',
    templateUrl: './prop-table.component.html',
    styleUrl: './prop-table.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PropTableComponent {


  @Output() sortChangeEvent = new EventEmitter();
  @Output('reloadDataEvent') reloadDataEvent = new EventEmitter<any>();
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
   @ViewChild('JustificationModal') JustificationModal;
  @ViewChild('justificationMessage') justificationMessage;
  @ViewChild('cancelOpenRequest') cancelOpenRequest;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() columns = [];
  @Input() requestStatus: string;
  @Input() sortDateColumn = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @Input() inputDataSource: any[];
  currentUser: string;
  @Input() propElement = [];
  @Input() lobData: any = [];
  @Input() resetSelectedLob: boolean = false;
  @Input() showMyPendRequest: boolean;
  @Input() proposalTableDataSource;
  @Input() closedProposalPopup: boolean = false;
  reopenedPopup: boolean = false;
  @Output() saveNewLobData: any[] = [];
  @Output('statusChangeEvent') statusChangeEvent = new EventEmitter();
  @Output('resetChangeEvent') resetChangeEvent = new EventEmitter();
  searchDropdownTxt: string = '';
  selectedReq: any;
  displayedColumns = [];
  filterApplied = [];
  filterValues = [];
  showResetFilters = false;
  filValue = [];
  filSubValue = [];
  filterList: any;
  searchValue: string;
  filterLists: any[];
  searchTxt = '';
  searchSubTxt = '';
  olddatasource: any[];
  Allfilter = [];
  selectedColumn: any;
  index = 0;
  triggerIndex = 0;
  comingFromClearFilter: boolean = false;
  selection = new SelectionModel<PeriodicElement>(true, []);
  @Output() selectedItemEvent = new EventEmitter<any>();
  @ViewChild('modalRoot') modalRoot;
  public selectedRequestId: string = "";
  public selectedRequestStatus: string = "Approved";
  fromMyRequests = false;
  payload: any;
  propDataSource: any;
  paramProprequestList: Array<any> = [];
  showParamFilterData: boolean = false;
  resetClicked: boolean;
  @Input() fromSummary;
  @Input() selectedOption: any;
  previousSelection: Array<any> = [];
  searchFilterLists: Array<any> = [];
  @Input() receivedData = false;
  originalDataSource: any;
  comment='';
  isInValidData = false;
  selectedElement: any;
  constructor(
    public toaster: ToastrService,
    private activeRoute: ActivatedRoute,
    public maintenanceService: MaintenanceService,
    private route: ActivatedRoute
  ) {
  }

  private toUtcMillis(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    if (value instanceof Date) {
      return value.getTime();
    }

    if (typeof value === 'number') {
      return value;
    }

    const str = String(value).trim();
    if (!str) {
      return 0;
    }

    // YYYY-MM-DD
    const ymdMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymdMatch) {
      const year = Number(ymdMatch[1]);
      const month = Number(ymdMatch[2]);
      const day = Number(ymdMatch[3]);
      return Date.UTC(year, month - 1, day);
    }

    // YYYY-MM-DD HH:mm:ss(.sss) OR YYYY-MM-DDTHH:mm:ss(.sss)
    const ymdTimeMatch = str.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2}(?:\.\d+)?)$/);
    if (ymdTimeMatch) {
      const ms = Date.parse(`${ymdTimeMatch[1]}T${ymdTimeMatch[2]}Z`);
      return Number.isNaN(ms) ? 0 : ms;
    }

    // ISO datetime; if timezone is missing, treat as UTC.
    if (/^\d{4}-\d{2}-\d{2}T/.test(str)) {
      const hasTimezone = /Z$|[+-]\d{2}:\d{2}$/.test(str);
      const ms = Date.parse(hasTimezone ? str : `${str}Z`);
      return Number.isNaN(ms) ? 0 : ms;
    }

    const fallback = Date.parse(str);
    return Number.isNaN(fallback) ? 0 : fallback;
  }

  private normalizeUtcTimestamp(value: any): any {
    if (typeof value !== 'string') {
      return value;
    }

    const str = value.trim();
    if (!str) {
      return value;
    }

    // If it's already timezone-qualified, keep as-is.
    if (/Z$|[+-]\d{2}:\d{2}$/.test(str)) {
      return str;
    }

    // YYYY-MM-DDTHH:mm:ss(.sss) -> treat as UTC
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(str)) {
      return `${str}Z`;
    }

    // YYYY-MM-DD HH:mm:ss(.sss) -> convert to ISO and treat as UTC
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(str)) {
      return `${str.replace(' ', 'T')}Z`;
    }

    return str;
  }

  private normalizeRowsForUtc(data: any[]): any[] {
    if (!Array.isArray(data)) {
      return data;
    }

    return data.map((item) => {
      if (!item || typeof item !== 'object') {
        return item;
      }

      return {
        ...item,
        created_at: this.normalizeUtcTimestamp(item.created_at),
        updated_at: this.normalizeUtcTimestamp(item.updated_at),
        Approver_1_timestamp: this.normalizeUtcTimestamp(item.Approver_1_timestamp),
        Approver_2_timestamp: this.normalizeUtcTimestamp(item.Approver_2_timestamp),
        Approver_3_timestamp: this.normalizeUtcTimestamp(item.Approver_3_timestamp),
      };
    });
  }
  ngOnInit() {
    this.activeRoute.queryParams.subscribe(params => {
      let requesList = params['id'];
      if (requesList) {
        requesList = requesList.replace(/['"]+/g, '');
        this.paramProprequestList = requesList.split(',');
        this.showParamFilterData = true;
      }
      else {
        this.showParamFilterData = false;
      }
    });
    this.displayedColumns = this.columns.map(element => element.columnDef);
    if (this.inputDataSource && this.receivedData) {
      const normalized = this.normalizeRowsForUtc(this.inputDataSource);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'created_at': return this.toUtcMillis(item.created_at);
          case 'updated_at': return this.toUtcMillis(item.updated_at);
          case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
          default: return item[property];
        }
      };
      this.olddatasource = normalized;
      this.dataSource.data = normalized;
      // this.ngOnChanges();
    }
  }
  ngAfterViewInit() {
    // Ensure paginator and sort are properly initialized after the view is loaded
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }

    //check for query params
    this.route.queryParams.subscribe(params => {
      if (params['Request_Id']) {
        this.selectedRequestId = params['Request_Id'];
        console.log('Request_Id found in query params:', this.selectedRequestId);
        this.getRecordFromOTL(this.selectedRequestId);
      } else {
        console.log('Request_Id not found in query params');
      }
    });
  }
  ngOnChanges() {

    if (this.inputDataSource && this.receivedData) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'created_at': return this.toUtcMillis(item.created_at);
          case 'updated_at': return this.toUtcMillis(item.updated_at);
          case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
          default: return item[property];
        }
      };
      const originalDataSource = this.normalizeRowsForUtc(JSON.parse(JSON.stringify(this.inputDataSource)));
      if (this.requestStatus.toLocaleLowerCase() == 'open' && this.fromSummary != undefined && this.showMyPendRequest != undefined) {
        this.dataSource.data = originalDataSource
      } else {
        this.dataSource.data = originalDataSource;
      }
      this.olddatasource = this.dataSource.data;
      if (this.showParamFilterData && this.olddatasource && this.olddatasource.length > 0 && !this.resetClicked && this.requestStatus == 'Open' && !this.fromSummary) {
        this.applyLocalFilterForURLdata();
      }
      this.propDataSource = this.dataSource.data.reduce((acc, item) => {
        const group = item.Work_queue;
        if (!acc[group]) acc[group] = [];
        acc[group].push(item);
        return acc;
      }, {});
      if (this.propElement.length) {
        this.propApplyLocalFilter();
      }
    }
    if ((!this.propElement.length && (!this.showParamFilterData || this.fromSummary))) {
      this.filterApplied = [];
      this.showResetFilters = false;
    }
    if (this.resetSelectedLob) {
      this.selection.clear();
    }

    this.Allfilter = [];
    this.filterValues = [];
    if (this.sortDateColumn) {
      const sortState: Sort = { active: 'created_at', direction: 'asc' };
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
    }
  }

  // Helper function to resolve approver name
  private resolveApproverName(data: any): string {
    return data["Approver_2_Name"] || data["Approver_1_Name"] || data["Approver_3_Name"] || data["updated_by"] || '';
  }


  //Filter functionality

  private closeOpenFilterMenus(): void {
    if (!this.trigger) return;
    this.trigger.toArray().forEach((item: MatMenuTrigger) => {
      if (item?.menuOpen) {
        item.closeMenu();
      }
    });
  }

  filterDropdown(column, index) {
    this.searchValue = '';
    this.searchTxt = '';
    if (["Rejected By", "Approved By", "Cancelled By", "Addressed By", "Requested By"].includes(column.header)) {
      this.triggerIndex = index - 1;
    } else {
      this.triggerIndex = index;
    }
    if (this.trigger)
      this.trigger.toArray().forEach((item: MatMenuTrigger, i: number) => {
        if (i !== this.triggerIndex && item.menuOpen) {
          item.closeMenu();
        }
      });
    this.selectedColumn = column;
    this.filterList = [];
    for (let i = 0; (i < 200 || this.filterList.length < 200) && i < this.dataSource.data.length; i++) {
      const approverName = this.resolveApproverName(this.dataSource.data[i]);
      if ((column.header === "Approved By" || column.header === "Cancelled By" || column.header === "Addressed By") && this.filterList.includes(approverName))
        continue;
      if(column.header == "Rejected By" && this.filterList.includes(this.dataSource.data[i]["updated_by"]))
        continue;
      if (this.filterList.includes(this.dataSource.data[i][column.columnDef]))
        continue;
      this.filterList.push((column.header === "Approved By" || column.header === "Cancelled By" || column.header === "Addressed By") ? approverName : this.dataSource.data[i][column.columnDef]);
    }
    this.filValue = this.filterValues[index];
    this.filterList = new Set([...this.filterList]);
    if (this.propElement.length > 0) {
      this.filterValues[index] = this.propElement;
      this.filValue = this.propElement;
      this.Allfilter.push({ col: column.columnDef, value: this.propElement });
    } else {
      this.filterValues[index] = [];
    }
    this.filterLists = Array.from(this.filterList);
    if (this.trigger)
      this.trigger.toArray()[this.triggerIndex].openMenu();
  }


  searchFunction(column) {
    column = this.selectedColumn;
    const filterLists = [];
    let selectedIds = 0;
    this.searchTxt = this.searchTxt.trim();
    const isApproverColumn = ["Approved By", "Cancelled By", "Addressed By"].includes(column.header);
    for (let i = 0; selectedIds < 200 && i < this.dataSource.data.length; i++) {
      const value = isApproverColumn
        ? this.resolveApproverName(this.dataSource.data[i])
        : this.dataSource.data[i][column.columnDef];
      if (String(value).toLowerCase().includes(this.searchTxt.toLowerCase())) {
        if (!filterLists.includes(value))
          filterLists.push(value);
        selectedIds++;
      }
    }
    this.searchFilterLists = filterLists;
  }
  selectionChange(event, column, index) {
    column = this.selectedColumn;
    this.Allfilter.forEach((a, i) => { if (a.col == column.columnDef) this.Allfilter.splice(i, 1) });
    const newevent = this.checkPrevious(event, this.filterValues[index]);
    if (newevent.source._value.length > 0) {
      this.filterValues[index] = newevent.source._value;
      this.Allfilter.push({ col: column.columnDef, value: newevent.source._value })
    } else {
      this.filterValues[index] = [];
    }
    this.trigger.toArray()[this.triggerIndex].openMenu();

  }
  propApplyLocalFilter() {
    let tempData = [];
    if (this.propDataSource[this.propElement[0]]) {
      this.propElement.forEach(element => {
        tempData = tempData.concat(this.propDataSource[element]);
      });
    }
    this.filterApplied[1] = true;
    this.showResetFilters = true;
    let propDef = this.columns.filter(element => element.columnDef == 'Work_queue')[0];
    this.selectedColumn = propDef;
    this.Allfilter = [{ col: propDef.columnDef, value: [this.propElement[0]] }];
    this.dataSource = new MatTableDataSource(tempData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'created_at': return this.toUtcMillis(item.created_at);
        case 'updated_at': return this.toUtcMillis(item.updated_at);
        case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
        default: return item[property];
      }
    };
  }

  applyLocalFilter(column, index) {
    this.searchTxt = '';

    if (!this.comingFromClearFilter && column.columnDef == 'Work_queue' && !this.showResetFilters) {
      let idx;
      this.Allfilter.map(element => {
        if (element.col == column.columnDef) {
          idx = element.value;
        }
      });
      this.filterApplied[index] = true;
      this.showResetFilters = true;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'created_at': return this.toUtcMillis(item.created_at);
          case 'updated_at': return this.toUtcMillis(item.updated_at);
          case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
          default: return item[property];
        }
      };
      let tempData = [];
      idx.forEach(element => {
        tempData = tempData.concat(this.propDataSource[element]);
      });
      this.dataSource.data = tempData;
      if (this.trigger)
        this.trigger.toArray()[this.triggerIndex].closeMenu();
      return;
    }

    let filterdata = this.olddatasource;
    this.Allfilter.forEach((e1) => {
      if (e1.value.length > 0) {
        filterdata = filterdata.filter((item) => {
          const approverName = this.resolveApproverName(item);
          return e1.value.some(e => e === (column.header === 'Approved By' || column.header === 'Addressed By' || column.header === 'Cancelled By' ? approverName : item[e1.col]));
        });
        this.filterLists = filterdata.map((item) => { return item[column.columnDef]; });
        if (!this.comingFromClearFilter) {
          this.filterApplied[index] = true;
          this.showResetFilters = true;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'created_at': return this.toUtcMillis(item.created_at);
            case 'updated_at': return this.toUtcMillis(item.updated_at);
            case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
            default: return item[property];
          }
        };
        this.dataSource.data = filterdata;
        if (this.trigger) {
          this.trigger.toArray()[this.triggerIndex].closeMenu();
          if (this.trigger.toArray()[1]) {
            this.trigger.toArray()[1].closeMenu();
          }
        }
      }
    });
    if (this.Allfilter.length == 0) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'created_at': return this.toUtcMillis(item.created_at);
          case 'updated_at': return this.toUtcMillis(item.updated_at);
          case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
          default: return item[property];
        }
      };
      this.dataSource.data = this.olddatasource;
      // When the last filter is cleared, ensure the menu closes.
      this.closeOpenFilterMenus();
    }
    this.comingFromClearFilter = false;
  }

  clearLocalFilter(column, index) {
    column = this.selectedColumn;
    this.searchTxt = '';
    this.closeOpenFilterMenus();
    this.previousSelection = [];
    this.filterValues[index] = [];
    this.filterApplied[index] = false;
    let resetFilter = true;
    this.filterApplied.forEach(ele => {
      if (ele) {
        resetFilter = false;
      }
    });
    if (resetFilter) {
      this.showResetFilters = false;
    }
    let tmpAllFilter = this.Allfilter.map(x => Object.assign({}, x));
    this.Allfilter.forEach((a) => {
      if (a.col == column.columnDef) {
        tmpAllFilter.splice(tmpAllFilter.findIndex(a => a.col == column.columnDef), 1);
      }
    });
    this.Allfilter = tmpAllFilter;
    this.comingFromClearFilter = true;
    this.applyLocalFilter(column, index);
  }
  clearallFilter() {
    let isReset = true;
    this.resetClicked = true;
    this.closeOpenFilterMenus();
    this.filterLists = [];
    this.filterApplied = [];
    this.Allfilter = [];
    this.filterValues = [];
    this.showResetFilters = false;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
          case 'created_at': return this.toUtcMillis(item.created_at);
          case 'updated_at': return this.toUtcMillis(item.updated_at);
          case 'completed_at': return this.toUtcMillis(item.Approver_2_timestamp || item.Approver_1_timestamp || '');
        default: return item[property];


      }
    };
    this.resetChangeEvent.emit(isReset);
    this.dataSource.data = this.olddatasource;
  }



  getRecord(element) {
    this.configureRequestStatusForUI();
    this.selectedRequestId = element.Request_Id;
    this.selectedElement = element;
    let element1 = <any>document.querySelector('.nav-color');
    if (element1)  element1.style.zIndex = 1;
    this.fromMyRequests = true;
    this.reopenedPopup = !this.reopenedPopup;
    this.closedProposalPopup = false;
    this.modalRoot.show();
  }

  getRecordFromOTL(reqId: string) {
    this.selectedRequestStatus = "Open";
    this.selectedRequestId = reqId;
    let element1 = <any>document.querySelector('.nav-color');
    if (element1)  element1.style.zIndex = 1;
    this.fromMyRequests = true;
    this.reopenedPopup = !this.reopenedPopup;

    this.modalRoot.show();
  }

  hidecancelpopup() {
    this.selectedReq = '';
    this.modalRoot.hide();
    this.reloadDataEvent.emit();
  }
  onModalClose(){
    this.closedProposalPopup = true;
  }

  configureRequestStatusForUI() {
    switch (this.requestStatus) {
      case 'Open':
        this.selectedRequestStatus = "Open";
        break;
      case 'Approved':
        this.selectedRequestStatus = "Approved";
        break;
      case 'Rejected':
        this.selectedRequestStatus = "Rejected";
        break;
      case 'Cancelled':
        this.selectedRequestStatus = "Cancelled";
        break;
      default:
        this.selectedRequestStatus = this.requestStatus;
        break;
    }
  }
  sortData(event) {

    let sort: any[] = [];
    if (event.direction) {
      sort = [[event.active, event.direction]];
    }
    this.sortChangeEvent.emit(sort);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
    this.selectedItemEvent.emit(this.selection.selected);

  }

  fieldValueChange(){
    if(this.comment !== '') {
      this.isInValidData = true;
    } else this.isInValidData = false;
  
  }




  applyLocalFilterForURLdata() {
    this.selectedColumn = {
      columnDef: "Request_Id",
      disable: false,
      filter: true,
      header: "Request ID",
      isSort: true,
      link: true,
      width: "12% !important"
    }
    const index = 0;
    const column = {
      columnDef: "Request_Id",
      disable: false,
      filter: true,
      header: "Request ID",
      isSort: true,
      link: true,
      width: "12% !important"
    }
    const ev = {
      source: {
        _value: this.paramProprequestList
      }
    }
    this.filterValues[index] = ev.source._value;
    this.Allfilter.push({ col: column.columnDef, value: ev.source._value })

    this.applyLocalFilter(column, 0);
  }

  checkPrevious(event, prevArr: any = []) {
    this.previousSelection = prevArr;
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName //check for element which is unchecked
          ) {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (this.filterLists.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (this.filterLists.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }

  onCancelClick(element: any) {
 
      this.selectedReq = element; // Store the selected request
      this.cancelOpenRequest.show(); // Show the modal
  }
  
  confirmCancel() {
      if (this.selectedReq) {
          const payload = {
            "requestId": this.selectedReq.Request_Id,
              "status": 'Cancelled',
              "justification": this.comment
          };

  
          this.maintenanceService.proposalStatusUpdate(payload).subscribe(
              (response) => {
                  if (response && response.message === "Proposal status updated successfully") {
                      this.toaster.success('Request cancelled successfully', '', { timeOut: 5000, positionClass: 'toast-top-center' });
                      this.reloadDataEvent.emit(); // Reload data after successful cancellation
                  } else {
                      this.toaster.error('Failed to cancel request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
                  }
              },
              () => {
                  this.toaster.error('Error occurred while cancelling request', '', { timeOut: 5000, positionClass: 'toast-top-center' });
              }
          );
      }
      this.cancelOpenRequest.hide(); // Close the modal
  }

  closeModal() {
    // Reset the selected request and hide the modal
    this.selectedReq = null;
    this.cancelOpenRequest.hide();
  }




}

